import JukinSchedule from "./JukinSchedule";

export default JukinSchedule.reducer.bind(JukinSchedule);
